import { render, staticRenderFns } from "./WriteOff.vue?vue&type=template&id=5eeb0f4a&"
import script from "@/scripts/Mall/WriteOff/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/WriteOff/index.js?vue&type=script&lang=js&"
import style0 from "./WriteOff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports